function fn_scrollreveal() {
    if (!$("html.sr").length && $("[data-reveal]").length) {
        window.sr = new ScrollReveal({ duration: 2000 });
        if (sr.isSupported()) {
            document.documentElement.classList.add('sr');
            $("section").each(function(){
                var c = $(this).attr("class").split(' ')[0];
                sr.reveal("."+c+" [data-reveal]", {
                    duration: 1000,
                    easing: 'ease',
                    scale: null,
                    distance: 0,
                    delay: 150,
                    viewFactor : 0.2,
                    reset: false,
                    container: document.getElementsByTagName("section"),
                    beforeReveal: function (domEl) {
                        if ($(domEl).attr("data-reveal") == "map") {
                            $(domEl).attr("data-reveal","revealed");
                            fn_comp_map();
                        } else {
                            $(domEl).attr("data-reveal","revealed");
                        }
                    },
                    afterReveal: function (domEl) {
                        $(domEl).removeAttr("style");
                    }
                },0);
            });

            $("[data-reveal-group]").each(function(){
                var c = $(this).attr("class").split(' ')[0];
                sr.reveal("."+c+" [data-reveal]", {
                    duration: 1000,
                    easing: 'ease',
                    scale: null,
                    distance: 0,
                    delay: 150,
                    viewFactor : 0.2,
                    reset: false,
                    container: document.getElementsByTagName("section"),
                    beforeReveal: function (domEl) {
                        $(domEl).attr("data-reveal","revealed");
                    },
                    afterReveal: function (domEl) {
                        $(domEl).removeAttr("style");
                    }
                },200);
            });
        }
    }
}